import BaseDropdown from "@/components/reusables/dropdowns/BaseDropdown";
import { Location } from "@/types/general";
import { Control, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { generateLocationLabel, LocationsMapperFormTyping } from "./utils";

interface SuppliLocationDropdownProps {
    control: Control<LocationsMapperFormTyping>;
    index: number;
    availableSuppliLocations?: Location.Merged[];
    isLoading: boolean;
}

export default function SuppliLocationDropdown({
    control,
    index,
    availableSuppliLocations,
    isLoading,
}: SuppliLocationDropdownProps) {
    const { t } = useTranslation("", {
        keyPrefix: "imports.modules.shopify.importModal.locationsMapper",
    });

    return (
        <Controller
            control={control}
            name={`mappings.${index}.suppli_location`}
            render={({ field, fieldState }) => (
                <BaseDropdown
                    {...field}
                    {...fieldState}
                    options={availableSuppliLocations}
                    getter={{
                        label: (opt) => generateLocationLabel(opt.store.name, opt.section?.name),
                        key: (opt) =>
                            opt.section ? `${opt.store.id}_${opt.section.id}` : `${opt.store.id}`,
                        renderOption: (opt, icon) => (
                            <div className="flex items-center justify-between w-full">
                                <div className="grow">
                                    <div className="bold-highlight">{opt.store.name}</div>
                                    {opt.section && (
                                        <div className="text-sm text-gray-500">
                                            {opt.section.name}
                                        </div>
                                    )}
                                </div>
                                {icon}
                            </div>
                        ),
                    }}
                    placeholder={t("fields.suppli.placeholder")}
                    isLoading={isLoading}
                    autocomplete
                />
            )}
        />
    );
}
